import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";

// api's
import { getSessions } from "../../api/sessionApi";
import { getGrades } from "../../api/gradeApi";
import { getCurriculumSubjectsByGrade } from "../../api/curriculumSubjectsApi";
import { getTeacherAssignments, bulkAssignSubjects } from "../../api/teacherAssignmentApi";



const AssignSubjectsModal = ({ visible, onHide, teacher }) => {
  const [sessions, setSessions] = useState([]);
  const [grades, setGrades] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      getSessions().then(setSessions);
      getGrades().then(setGrades);
    }
  }, [visible]);

  useEffect(() => {
    if (selectedGrade && selectedSession) {
      getCurriculumSubjectsByGrade(selectedGrade).then((curriculum) => {
        const subjectOptions = curriculum.data.map(cs => cs.subject);
        setSubjects(subjectOptions);
      });

      if (teacher && teacher.id) {
        getTeacherAssignments(teacher.id).then(assignments => {
          const existingSubjectIds = assignments
            .filter(a => a.grade_id === selectedGrade && a.session_id === selectedSession)
            .map(a => a.subject_id);
          setSelectedSubjects(existingSubjectIds);
        });
      } else {
        setSelectedSubjects([]);
      }
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedGrade, selectedSession, teacher && teacher.id]);

  const handleSave = async () => {
    if (!selectedSession || !selectedGrade || !teacher) {
      toast.error("Please select a session and a grade.");
      return;
    }
    setLoading(true);
    try {
      await bulkAssignSubjects({
        teacher_id: teacher.id,
        grade_id: selectedGrade,
        session_id: selectedSession,
        subject_ids: selectedSubjects,
      });
      toast.success("Assignments saved successfully!");
      onHide();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save assignments.");
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div>
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
      <Button label="Save" icon="pi pi-check" onClick={handleSave} loading={loading} autoFocus />
    </div>
  );

  return (
    <Dialog header={`Assign Subjects to ${teacher?.user?.name}`} visible={visible} style={{ width: "40vw" }} onHide={onHide} footer={footer}>
      <div className="p-fluid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="session">Academic Session</label>
          {/* <InputText id="session" type="text" value={sessions?.name || ""} disabled placeholder={sessions.name} /> */}
          <Dropdown id="session" value={selectedSession} options={sessions} onChange={(e) => setSelectedSession(e.value)} optionLabel="name" optionValue="id" placeholder="Select a Session" />
        </div>
        <div className="field col-12 md:col-6">
          <label htmlFor="grade">Grade</label>
          <Dropdown id="grade" value={selectedGrade} options={grades} onChange={(e) => setSelectedGrade(e.value)} optionLabel="name" optionValue="id" placeholder="Select a Grade" />
        </div>
        <div className="field col-12">
          <label htmlFor="subjects">Subjects</label>
          <MultiSelect
            id="subjects"
            value={selectedSubjects}
            options={subjects}
            onChange={(e) => setSelectedSubjects(e.value)}
            optionLabel="name"
            optionValue="id"
            placeholder="Select Subjects"
            disabled={!selectedGrade || !selectedSession}
            display="chip"
            className="w-full"
          />
        </div>
      </div>
    </Dialog>
  );
};

export default AssignSubjectsModal;
